"use strict";
const YOUTUBE_ID = /^[A-Za-z0-9_-]{11}$/u;
const VIMEO_ID = /^\d{6,12}$/u;
const YOUTUBE_HOSTS = /* @__PURE__ */ new Set(["youtube.com", "www.youtube.com", "m.youtube.com", "youtu.be"]);
const VIMEO_HOSTS = /* @__PURE__ */ new Set(["vimeo.com", "www.vimeo.com", "player.vimeo.com"]);
const secureVideoUrl = (value) => {
  if (!value || /[<>]/u.test(value)) {
    return null;
  }
  try {
    const url = new URL(value);
    const invalidPort = url.port && url.port !== "443";
    return url.protocol === "https:" && !url.username && !url.password && !invalidPort ? url : null;
  } catch (_error) {
    return null;
  }
};
const youtubeVideo = (url, host, parts) => {
  let identifier = null;
  if (host === "youtu.be" && parts.length === 1) {
    [identifier] = parts;
  } else if (url.pathname === "/watch") {
    identifier = url.searchParams.get("v");
  } else if (parts.length === 2 && ["embed", "shorts"].includes(parts[0])) {
    identifier = parts[1];
  }
  if (!YOUTUBE_ID.test(identifier || "")) {
    return null;
  }
  return { provider: "YouTube", src: `https://www.youtube-nocookie.com/embed/${identifier}` };
};
const vimeoVideo = (host, parts) => {
  let identifier = null;
  if (["vimeo.com", "www.vimeo.com"].includes(host) && parts.length === 1) {
    [identifier] = parts;
  } else if (host === "player.vimeo.com" && parts.length === 2 && parts[0] === "video") {
    identifier = parts[1];
  }
  if (!VIMEO_ID.test(identifier || "")) {
    return null;
  }
  return { provider: "Vimeo", src: `https://player.vimeo.com/video/${identifier}` };
};
const parseVideo = (value) => {
  const url = secureVideoUrl(value);
  if (!url) {
    return null;
  }
  const host = url.hostname.toLowerCase().replace(/\.$/u, "");
  const parts = url.pathname.split("/").filter(Boolean);
  if (YOUTUBE_HOSTS.has(host)) {
    return youtubeVideo(url, host, parts);
  }
  if (VIMEO_HOSTS.has(host)) {
    return vimeoVideo(host, parts);
  }
  return null;
};
const createPreview = (root, parsed) => {
  const preview = root.querySelector("[data-initiative-video-preview]");
  if (!preview) {
    return;
  }
  preview.replaceChildren();
  if (!parsed) {
    return;
  }
  const heading = document.createElement("p");
  heading.className = "initiative-video-preview__title";
  heading.textContent = root.dataset.previewTitle;
  const iframe = document.createElement("iframe");
  iframe.src = parsed.src;
  iframe.title = `${parsed.provider} video preview`;
  iframe.loading = "lazy";
  iframe.referrerPolicy = "strict-origin-when-cross-origin";
  iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
  iframe.allowFullscreen = true;
  const frame = document.createElement("div");
  frame.className = "initiative-video__frame";
  frame.appendChild(iframe);
  const wrapper = document.createElement("div");
  wrapper.className = "initiative-video";
  wrapper.appendChild(frame);
  preview.append(heading, wrapper);
};
const showInvalid = (root) => {
  const preview = root.querySelector("[data-initiative-video-preview]");
  if (!preview) {
    return;
  }
  preview.replaceChildren();
  const error = document.createElement("p");
  error.className = "form-error is-visible";
  error.dataset.initiativeVideoError = "true";
  error.textContent = root.dataset.invalidMessage;
  preview.appendChild(error);
};
const initializeInitiativeVideoFields = () => {
  document.querySelectorAll("[data-initiative-video-field]").forEach((root) => {
    const input = root.querySelector("[data-initiative-video-url]");
    if (!input || input.dataset.videoPreviewInitialized === "true") {
      return;
    }
    input.dataset.videoPreviewInitialized = "true";
    input.addEventListener("input", () => {
      const value = input.value.trim();
      if (!value) {
        createPreview(root, null);
        return;
      }
      const parsed = parseVideo(value);
      if (parsed) {
        createPreview(root, parsed);
      } else {
        showInvalid(root);
      }
    });
  });
};
document.addEventListener("DOMContentLoaded", initializeInitiativeVideoFields);
document.addEventListener("turbo:load", initializeInitiativeVideoFields);
